// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-create-application-location-bpi) {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.verify-row {
  display: flex;
}

.lookup-verify-row {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
}

.lookup-field {
  flex: 1 1 220px;
  min-width: 220px;
}

.lookup-action {
  flex: 0 0 auto;
  padding-top: 21px;
}

.toolbar-headings {
  margin-left: 57.5px;
  justify-content: space-between;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: -0.0960779px;
  width: 170px;
}

.menu-item-text {
  color: #B2B2B2;
  font-weight: 600;
  text-align: center;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.083333px;
}

.active-heading {
  color: var(--theme-main-color, #055C8D);
}

.sidebar {
  mix-blend-mode: normal;
  background-color: rgba(234, 234, 234, 0.29);
  width: 200px;
  flex-basis: 200px;
  min-width: 200px;
}

.map {
  margin-right: 10px;
}

.map-row {
  min-height: 37vh;
  max-height: 70vh;
}

.row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.remove-button {
  margin-left: 10px;
}

.last-row {
  margin-top: 5px;
  margin-bottom: 5px;
}

.div-margin {
  margin-bottom: -10px;
}

.missing-zones-label {
  font-size: 13px;
  color: #000000;
  padding: 0;
}

.action-button {
  margin-left: 5px;
}

.button-row {
  margin-bottom: 5px;
}

.deceased-table {
  height: 305px;
}

.table {
  height: 300px;
  margin-bottom: 0rem;
}

.total-input {
  background-color: #e9ecef !important;
}

.description-text {
  resize: none;
  border: none Transparent;
  outline: none;
  height: 50px;
  color: #2C2B2D;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  padding-left: 10px;
  width: 100%;
}

.form-select {
  width: 100% !important;
}

.form-control {
  width: 100% !important;
}

.form-control:disabled {
  background-color: lightgray !important;
}

.filter-bar {
  width: 100% !important;
}

.filter-by {
  margin-left: 10px;
  margin-right: 20px;
}

.content-panel {
  overflow-y: auto;
  overflow-x: auto;
  min-height: 0;
  margin-bottom: 5px !important;
}

.w-100 {
  width: 100% !important;
  margin-top: 0px !important;
}

.label-margin {
  margin-top: 30px;
}

.sub-label-margin-top {
  margin-top: 20px;
}

.building-margin-top {
  margin-top: 15px;
}

.building-padding-bottom {
  padding-bottom: 5px;
}

.button-panel-margin-top {
  margin-top: 15px;
  margin-right: 15px !important;
}

.description-padding {
  padding-bottom: 10px;
}

.reference-number-padding {
  padding-bottom: 10px;
}

.nav-tabs {
  margin-top: 15px !important;
  margin-bottom: 15px !important;
}

h5, .h5 {
  font-size: 1.25rem;
  color: var(--theme-main-darker-color, #053551);
}

input:disabled {
  background-color: lightgray !important;
}

textarea:disabled {
  background-color: lightgray !important;
}

select:disabled {
  background-color: lightgray !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
